import { LabelVariant } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';

import { DrawInspectionStatus, DrawRequestStatus } from 'store/construction/types';

export const CONSTRUCTION_BUDGET_COLUMN_KEY = {
  COST_CODE: 'costCode',
  DESCRIPTION: 'description',
  BUDGETED: 'budgeted',
  FUNDED_TO_DATE: 'fundedToDate',
  THIS_DRAW: 'thisDraw',
  REMAINING: 'remaining',
  PERCENT_COMPLETE: 'percentComplete',
};

export const DRAW_LIST_COLUMN_KEY = {
  DRAW: 'draw',
  REQUESTED: 'requested',
  APPROVED: 'approved',
  STATUS: 'status',
  INSPECTION: 'inspection',
  REQUEST_DATE: 'requestDate',
  ACTIONS: 'actions',
};

export const DRAW_STATUS_LABEL = {
  [DrawRequestStatus.SUBMITTED]: { title: 'Submitted', variant: LabelVariant.BLUE },
  [DrawRequestStatus.UNDER_REVIEW]: { title: 'Under Review', variant: LabelVariant.ORANGE },
  [DrawRequestStatus.INSPECTION]: { title: 'Inspection', variant: LabelVariant.PURPLE },
  [DrawRequestStatus.APPROVED]: { title: 'Approved', variant: LabelVariant.BLUE },
  [DrawRequestStatus.DISBURSED]: { title: 'Disbursed', variant: LabelVariant.GREEN },
  [DrawRequestStatus.REJECTED]: { title: 'Rejected', variant: LabelVariant.RED },
};

export const DRAW_INSPECTION_LABEL = {
  [DrawInspectionStatus.NOT_ORDERED]: { title: 'Not Ordered', variant: LabelVariant.BLUE_GRAY },
  [DrawInspectionStatus.ORDERED]: { title: 'Ordered', variant: LabelVariant.BLUE },
  [DrawInspectionStatus.SCHEDULED]: { title: 'Scheduled', variant: LabelVariant.BLUE },
  [DrawInspectionStatus.PASSED]: { title: 'Passed', variant: LabelVariant.GREEN },
  [DrawInspectionStatus.FAILED]: { title: 'Failed', variant: LabelVariant.RED },
};

// The five lifecycle stages a draw moves through, rendered by StepperCDS. A rejected draw stops at
// the review stage, so the rejected status maps onto Under Review for stepper positioning.
export const DRAW_LIFECYCLE_STEPS = [
  { label: 'Submitted', value: DrawRequestStatus.SUBMITTED },
  { label: 'Under Review', value: DrawRequestStatus.UNDER_REVIEW },
  { label: 'Inspection', value: DrawRequestStatus.INSPECTION },
  { label: 'Approved', value: DrawRequestStatus.APPROVED },
  { label: 'Disbursed', value: DrawRequestStatus.DISBURSED },
];
